"use strict";

/**
 * URL-Objekt.
 *
 * @typedef {{scheme: (string), host: (string), port: (string), user: (string), pass: (string), path: (string), query: (string), queryObject: {}, fragment: (string)}} gc.gis.GCUrl
 */

/**
 *	Statische Klasse für die Verarbeitung einer URL.
 *
 *	@class
 *	@static
 *	@author	Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.GCUrl = {

	/**
	 * Erzeugt ein URL-Objekt anhand eines URL.
	 *
	 * @param {string} url
	 * @return gc.gis.GCUrl
	 */
	fromString: function (url)
	{
		var parser = document.createElement('a'),
			queryObject = {},
			queries, split, i;

		// lass den Browser arbeiten
		parser.href = url;

		// query string in Objekt überführen
		if (parser.search !== '')
		{
			queries = parser.search.replace(/^\?/, '').split('&');
			for (i = 0; i < queries.length; i++)
			{
				split = queries[i].split('=');
				if (undefined !== split[1])
				{
					queryObject[split[0]] = split[1];
				}
			}
		}

		return {
			scheme: parser.protocol.substring(0, parser.protocol.length-1),   // ohne :
			host: parser.hostname || parser.host, // host enthält im IE 11 noch den Port, Hostname nicht, in allen anderen Browsern ist host und hostname identisch
			// hostname: parser.hostname,
			port: parser.port,
			user: parser.username,
			pass: parser.password,
			path: parser.pathname,
			query: parser.search,
			queryObject: queryObject,
			fragment: parser.hash.substring(1)  // ohne #
		};
	},

	/**
	 * Erzeugt eine URL aus einem String. Dabei können Query-Paramete gesetzt bzw. überschrieben werden.
	 *
	 * @param {string} strUrl Basis-URL
	 * @param {Object<string,string>} queryObject Query-Parameter
	 * @return {string}
	 */
	buildUrl: function(strUrl, queryObject)
	{
		var url = this.fromString(strUrl);
		return this.toString(url, queryObject);
	},

	/**
	 * Erzeugt eine URL. Dabei können Query-Paramete neu gesetzt bzw. überschrieben werden.
	 *
	 * @param {gc.gis.GCUrl} url URL
	 * @param {Object<string,string>} [opt_queryObject] Query-Parameter
	 * @return {string}
	 */
	toString: function(url, opt_queryObject)
	{
		opt_queryObject = opt_queryObject || {};

		var query = gc.gis.GCUtil.assign(url.queryObject, opt_queryObject);

		return url.scheme + (url.scheme ? '://' : '')
			+ url.host
			+ (url.port ? ':' : '') + url.port
			+ (url.path.length > 0 && url.path.substr(0, 1) !== '/' ? '/' + url.path : url.path)    // path enthält im IE 11 keinen führenden /, in allen anderen Browsern schon
			+ this._queryToString(query)
			+ (url.fragment ? '#' : '') + url.fragment;
	},

	/**
	 * Setzt die Query-Paramete einer URL, dabei werden die bestehenden Parameter überschrieben.
	 *
	 * @param {gc.gis.GCUrl} url URL
	 * @param {Object<string,string>} queryObject Query-Parameter
	 */
	setQuery: function(url, queryObject)
	{
		url.queryObject = queryObject;
		url.query = this._queryToString(queryObject);
	},

	/**
	 * Setzt die Query-Paramete einer URL zurück.
	 *
	 * @param {gc.gis.GCUrl} url URL
	 */
	resetQuery: function(url)
	{
		this.setQuery(url, {})
	},

	/**
	 * Prüft, ob die angegebene Zeichenkette eine gültige URL ist.
	 *
	 * @method
	 * @param {string} url
	 * @return {boolean}
	 * @public
	 */
	isUrl: function(url)
	{
		//var re = /http(s)?:\/\/[\w-]+(\.[\w-]*)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/g;
		// siehe https://gist.github.com/dperini/729294
		var re = new RegExp(
			"^" +
			// protocol identifier
			"(?:(?:https?|ftp)://)" +
			// user:pass authentication
			"(?:\\S+(?::\\S*)?@)?" +
			"(?:" +
			// IP address exclusion
			// private & local networks
			"(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
			"(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
			"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
			// IP address dotted notation octets
			// excludes loopback network 0.0.0.0
			// excludes reserved space >= 224.0.0.0
			// excludes network & broacast addresses
			// (first & last IP address of each class)
			"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
			"(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
			"(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
			"|" +
			// host name
			"(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
			// domain name
			"(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
			// TLD identifier
			"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
			// TLD may end with dot
			"\\.?" +
			")" +
			// port number
			"(?::\\d{2,5})?" +
			// resource path
			"(?:[/?#]\\S*)?" +
			"$", "i"
		);

		return re.test(url);
	},

	/**
	 * Klont ein URL-Objekt.
	 *
	 * @param {gc.gis.GCUrl} url URL
	 * @return {gc.gis.GCUrl}
	 */
	clone: function(url)
	{
		return gc.gis.GCUtil.assign({}, url);
	},

	/**
	 * @param {Object<string,string>} query Query-Parameter
	 * @return {string}
	 * @private
	 */
	_queryToString: function (query)
	{
		var q = [], key;

		for (key in query)
		{
			q.push(key + "=" + encodeURIComponent(query[key]));
		}

		return (q.length ? '?' : '') + q.join('&');
	}
};